import React from 'react';
import { faqCategories } from '../../data/faqs';
import { Accordion } from '../ui/Accordion';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
export function FaqPreview() {
  const items = [...faqCategories[0].items.slice(0, 2), ...faqCategories[1].items.slice(1, 3)];
  return <section className="bg-white py-24 md:py-32" data-id="element-172" data-mp="12htd92vbb0px">
      <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-173" data-mp="2040k6jf3955g">
        <div className="lg:col-span-4" data-id="element-174" data-mp="203iih79npyq5">
          <SectionHeading kicker="FAQs" title="Common questions." intro="For employers, candidates and leaders considering a confidential search." data-id="element-175" data-mp="1v4nmf3moido3" />
          <Button to="/faq" variant="outline" arrow className="mt-8" data-id="element-176" data-mp="1qcnsbrtaiezf">
            All FAQs
          </Button>
        </div>
        <div className="lg:col-span-8" data-id="element-177" data-mp="1ldjhyxumqb7i">
          <Accordion items={items} defaultOpen={0} data-id="element-178" data-mp="2iv1euv96eej7" />
        </div>
      </div>
    </section>;
}